module.exports = require("./iso-to-lat-lng.json");